import React from 'react'
import { object, node, number } from 'prop-types'
import GoogleMapReact from 'google-map-react'

function createMapOptions(maps) {
	return {
		fullscreenControl: false,
		mapTypeControl: true,
		streetViewControl: true,
	}
}

GoogleMapsReactWrap.propTypes = {
	center: object.isRequired,
	children: node.isRequired,
	zoom: number.isRequired,
}

/* *** NOTE: Theme Provider will need to be redefined for top level child that is wrapped by GoogleMapReact */
export function GoogleMapsReactWrap({ children, center, zoom }) {
	return (
		<GoogleMapReact
			bootstrapURLKeys={{ key: process.env.GOOGLE_MAPS_GEOCODING_API_KEY }}
			center={center}
			defaultZoom={zoom}
			options={createMapOptions}
		>
			{children}
		</GoogleMapReact>
	)
}
